import browser from './utils/browser';

export default class Config
{
    #container;
    #src;
    #poster;
    #defaultQualityHeight;
    #defaultSubtitleLang;
    #autoStartLoad;
    #nativeControls;
    #autoplay;
    #debug;

    constructor({
        element,
        src,
        poster,
        defaultQualityHeight,
        defaultSubtitleLang,
        autoStartLoad = true,
        nativeControlsDetect,
        nativeControls = false,
        autoplay = false,
        debug = false
    })
    {
        if (!element) {
            throw new Error(`Config 'element' is not defined`);
        }

        if (!src) {
            throw new Error(`Config 'src' is not defined`);
        }

        this.#container = element;

        this.#src = src;

        this.#poster = poster;

        this.#defaultQualityHeight = defaultQualityHeight;

        this.#defaultSubtitleLang = defaultSubtitleLang;

        this.#autoStartLoad = autoStartLoad;

        if (nativeControlsDetect) {
            this.#nativeControls = browser.isMobile && browser.isiOS;
        } else {
            this.#nativeControls = nativeControls;
        }

        this.#autoplay = autoplay;

        this.#debug = debug;
    }

    get container()
    {
        return this.#container;
    }

    get src()
    {
        return this.#src;
    }

    get poster()
    {
        return this.#poster;
    }

    get defaultQualityHeight()
    {
        return this.#defaultQualityHeight;
    }

    get defaultSubtitleLang()
    {
        return this.#defaultSubtitleLang;
    }

    get autoStartLoad()
    {
        return this.#autoStartLoad;
    }

    get nativeControls()
    {
        return this.#nativeControls;
    }

    get autoplay()
    {
        return this.#autoplay;
    }

    get debug()
    {
        return this.#debug;
    }

    get hlsConfig()
    {
        return {debug: this.debug, autoStartLoad: this.autoStartLoad};
    }
};